import { LinkButton, Modal, Typography } from '@vtblife/uikit';
import React, { useCallback } from 'react';
import classname from '@search/classname/src';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';
import { abbreviateNumber } from '@search/helpers/src/formatNumber';
import { useClassifiedOfferDataLayerPush } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import Image from '../../../Image';
import LogoSet from '../images/icons/LogoSet.url.svg';
import './styles.css';
import { LandMortgageActionType } from '../constants';

const cn = classname.bind(null, 'LandMortgageCalcModal');

export const LandMortgageCalcModal = ({
    onClose,
    creditSum,
    isMobile,
    onRequest
}: {
    onClose: () => void;
    creditSum: number;
    isMobile: boolean;
    onRequest: (actionType: LandMortgageActionType) => void;
    }) => {
    const staticPath = useStaticPathConfig();
    const dataLayerPush = useClassifiedOfferDataLayerPush();

    const title = (
        <div className={cn('modal-title')}>
            <Typography>Постройте дом мечты c M2</Typography>
            <Image url={`${staticPath}${LogoSet}`} loading='lazy' alt='лого' />
        </div>
    );

    const handleLearnMore = useCallback(() => {
        dataLayerPush({
            event: 'up_action',
            theme: 'ipoteka',
            page_type: 'card',
            type: LandMortgageActionType.IzhsLearnMore
        });
    }, [ dataLayerPush ]);

    return (
        <Modal
            closable
            opened
            onClose={onClose}
            mobile={isMobile}
            swipeToClose={! isMobile}
        >
            <div className={cn()}>
                { isMobile ? <Modal.Header>Ипотека на строительство дома</Modal.Header> : <Modal.Title>{title}</Modal.Title>
                }
                <Modal.Content scrollable={isMobile}>
                    { isMobile && <Typography variant='h4'>{title}</Typography> }
                    <Typography>Условия кредитования:</Typography>
                    <div className={cn('data')}>
                        <div className={cn('cell')}>
                            <Typography variant='secondary-alone' color='secondary'>Ставка</Typography>
                            <Typography variant='h2' className={cn('rate-text')}>от 6,6 %</Typography>
                        </div>
                        <div className={cn('cell')}>
                            <Typography variant='secondary-alone' color='secondary'>Сумма кредита</Typography>
                            <Typography bold>до {abbreviateNumber(creditSum).value} {abbreviateNumber(creditSum).type} ₽</Typography>
                        </div>
                        <div className={cn('cell')}>
                            <Typography variant='secondary-alone' color='secondary'>Первоначальный взнос</Typography>
                            <Typography bold>от 20%</Typography>
                        </div>
                        <div className={cn('cell')}>
                            <Typography variant='secondary-alone' color='secondary'>Срок кредита</Typography>
                            <Typography bold>до 30 лет</Typography>
                        </div>
                        <div className={cn('cell')}>
                            <Typography variant='secondary-alone' color='secondary'>Программы</Typography>
                            <Typography variant='secondary' bold>Господдержка, IT-ипотека, семейная, стандартная</Typography>
                        </div>
                    </div>
                    <div className={cn('buttons-section')}>
                        <LinkButton
                            variant='accent'
                            fullWidth
                            onClick={() => onRequest(LandMortgageActionType.IzhsCalcReq)}
                            size='m'
                        >
                            Подать заявку
                        </LinkButton>
                        <LinkButton
                            variant='secondary'
                            fullWidth
                            size='m'
                            onClick={handleLearnMore}
                            href='https://m2.ru/ipoteka/stroitelstvo-doma/'
                            target='blank'
                        >
                            Узнать больше о программе
                        </LinkButton>
                    </div>
                    <Typography className={cn('modal-tip')}>
                        Перейдите к заявке на ипотеку, чтобы посмотреть подробный расчёт и предложения банков
                    </Typography>
                </Modal.Content>
            </div>
        </Modal>
    );
};
